import { EnvironmentProviders, Provider } from "@angular/core";
import { provideHttpClient } from "@angular/common/http";
import { LoginService } from "@app/core/user/domain/services/login.service";
import { LoginActionService } from "@app/core/user/data/service/login-action.service";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { TokenRepo } from "@app/core/shared/domain/token.repo";
import { TokenDataRepo } from "@app/core/shared/data/respository/token-data.repo";
import { ResetPasswordService } from "@app/core/user/domain/services/reset-password.service";
import { ResetPasswordActionService } from "@app/core/user/data/service/reset-password-action.service";
import { IsFirstTimeDataRepo } from "@app/core/user/data/repository/is-first-time-data.repo";
import { IsFirstTimeRepo } from "@app/core/user/domain/repositories/is-first-time.repo";
import { UserDataRepo } from "@app/core/user/data/repository/user-data.repo";
import { UserRepo } from "@app/core/user/domain/repositories/user.repo";
import { PlayerRepo } from "@app/core/match/domain/player.repo";
import { PlayerDataRepo } from "@app/core/match/data/repository/player-data.repo";
import { StatisticsRepo } from "@app/core/statistics/domain/statistics.repo";
import { StatisticsDataRepo } from "@app/core/statistics/data/repository/statistics-data.repo";
import { MatchDataRepo } from "@app/core/match/data/repository/match-data.repo";
import { MatchRepo } from "@app/core/match/domain/match.repo";
import { StepRepo } from "@app/core/on-boarding/domain/step.repo";
import { StepDataRepo } from "@app/core/on-boarding/data/repository/step-data.repo";
import { ThirdPartyLoginService } from "@app/core/user/domain/services/third-party-login.service";
import { ThirdPartyLoginActionService } from "@app/core/user/data/service/third-party-login-action.service";
import { UrlDataRepo } from "@app/core/urls/data/repository/url-data.repo";
import { UrlRepo } from "@app/core/urls/domain/url.repo";
import { PushNotificationsService } from "@app/core/notifications/domain/push-notifications.service";
import { LibraryPushNotificationsService } from "@app/core/notifications/data/service/library-push-notifications.service";
import { DeviceDAO } from "@app2u/notifications";
import { LocalStorageDeviceDAO } from "@app/core/notifications/data/local/local-storage-device.dao";
import { Capacitor } from "@capacitor/core";
import { FakePushNotificationService } from "@app/core/notifications/data/service/fake-push-notification.service";
import { BookingRepo } from "@app/core/booking/domain/booking-repo";
import { BookingDataRepo } from "@app/core/booking/data/repository/booking-data.repo";
import { ClubRepo } from "@app/core/club/domain/club.repo";
import { ClubDataRepo } from "@app/core/club/data/repository/clubs-data.repo";
import { CommunityRepo } from "@app/core/community/domain/community.repo";
import { CommunityDataRepo } from "@app/core/community/data/repository/community-data.repo";
import { CommunityPlayersRepo } from "@app/core/community/domain/community-players.repo";
import { CommunityPlayersDataRepo } from "@app/core/community/data/repository/community-players-data.repo";
import { CourtRepo } from "@app/core/court/domain/court.repo";
import { CourtDataRepo } from "@app/core/court/data/repository/court-data.repo";
import { VersionRepo } from "@app/core/version/domain/version.repo";
import { VersionDataRepo } from "@app/core/version/data/repository/version-data.repo";
import { ContactDataRepo } from "@app/core/contact/data/contact-data.repo";
import { ContactRepo } from "@app/core/contact/domain/contact.repo";
import { ChatRepo } from "@app/core/chat/domain/chat.repo";
import { ChatDataRepo } from "@app/core/chat/data/repository/chat-data.repo";
import { ShareMessageRepo } from "@app/core/share-message/domain/share-message.repo";
import { ShareMessageCapacitorImplRepo } from "@app/core/share-message/infrastructure/repository/share-message-capacitor-impl.repo";
import { OpenBrowserUrlRepo } from "@app/core/open-browser-url/domain/open-browser-url.repo";
import { OpenBrowserUrlRepoImpl } from "@app/core/open-browser-url/infrastructure/repository/open-browser-url.repo-impl";
import { AppUtils } from "@app/presentation/utils/app.utils";
import { ShareMessageMobileWebImplRepo } from "@app/core/share-message/infrastructure/repository/share-message-mobile-web-impl.repo";
import { ShareMessageDesktopWebImplRepo } from "@app/core/share-message/infrastructure/repository/share-message-desktop-web-impl.repo";
import { UserNotificationRepository } from "@app/core/notifications/domain/user-notification.repository";
import { UserNotificationDataRepository } from "@app/core/notifications/repository/user-notification-list-data.repository";
import { WhatsappRepo } from "@app/core/whatsapp/domain/whatsapp.repo";
import { WhatsappImplRepo } from "@app/core/whatsapp/infrastucture/whatsapp.repo-imp";
import { CoachRepo } from "@app/core/coach/domain/coach.repo";
import { CoachRepoImpl } from "@app/core/coach/infrastructure/coach.repo-impl";
import { MarketingMessageRepo } from "@app/core/marketing/domain/marketing-message.repo";
import { MarketingMessageRepoImpl } from "@app/core/marketing/data/repository/marketing-message.repo-impl";
import { UserProfilePictureRepo } from "@app/core/user/domain/repositories/user-profile-picture.repo";
import { UserCapacitorRepo } from "@app/core/user/data/repository/user-capacitor.repo";
import { WalletRepo } from "@app/core/wallet/domain/repository/wallet.repo";
import { WalletDataRepo } from "@app/core/wallet/infraestructure/repository/wallet-data.repo";
import { RechargeWalletService } from "@app/core/wallet/domain/service/recharge-wallet.service";
import { RechargeWalletDataService } from "@app/core/wallet/infraestructure/service/recharge-wallet-data.service";
import { MatchPlayerRepo } from "@app/core/match-player/domain/match-player.repo";
import { MatchPlayerDataRepo } from "@app/core/match-player/data/match-player-data.repo";
import { UserConfigurationRepo } from "@app/core/user/domain/repositories/user-configuration.repo";
import { UserConfigurationDataRepo } from "@app/core/user/data/repository/user-configuration-data.repo";
import { IsWalletAvailableService } from "@app/core/wallet/domain/service/is-wallet-available.service";
import { IsWalletAvailableDataService } from "@app/core/wallet/infraestructure/service/is-wallet-available-data.service";
import { RecentDataRepo } from "@app/core/recent-data/domain/recent-data.repo";
import { GetRecentDataDataRepo } from "@app/core/recent-data/data/repository/get-recent-data-data.repo";
import { APP_INITIALIZER, ErrorHandler } from "@angular/core";
import { Router } from "@angular/router";
import * as Sentry from "@sentry/angular";
import { LanguageService } from "@app/presentation/services/language.service";
import { InternalApiRepo } from "@app/core/internal-api/domain/internal-api.repo";
import { InternalApiDataRepo } from "@app/core/internal-api/data/repository/internal-api-data.repo";

//Fake providers for testing
const fakeProviders: Provider[] = [
  //{ provide: GetMarketingMessageWS, useClass: GetMarketingMessageFakeWS },
  //{ provide: GetAllMessagesAndBannersWS, useClass: GetAllMessagesAndBannersFakeWS },
  //{ provide: MatchWS, useClass: MatchFakeWS },
  //{ provide: GetBookingsWS, useClass: GetBookingsFakeWS },
  //{ provide: MatchDetailWS, useClass: MatchDetailFakeWS },
  //{ provide: AggregateStatisticsWS, useClass: AggregateStatisticsWsFake },
  //{ provide: GetMinimumVersionWS, useClass: GetMinimumVersionFakeWS },
  //{ provide: GetAppVersionDAO, useClass: GetAppVersionFakeDAO },
  //{ provide: GetBookingWS, useClass: GetBookingFakeWS },
  //{ provide: PlayerWS, useClass: PlayerWSFakeErrorAlreadySelected },
  //{ provide: PlayerWS, useClass: BaseHandlerFakeNoInternet },
  /**To test if a player is already identified */
  /*{
    provide: PlayerIdentificationInformationWS,
    useClass: PlayerIdentificationInformationWSFake,
  },*/
];

const fakeAPIErrorProviders: Provider[] = [
  //{ provide: BaseHandler, useClass: BaseHandlerFakeNoInternet },
  //{ provide: BaseHandler, useClass: BaseHandlerFakeUnauthorizedError },
  //{ provide: BaseHandler, useClass: BaseHandlerFakeInternalServerError },
  //{ provide: BaseHandler, useClass: BaseHandlerFakeOtherError },
  //{ provide: BaseHandler, useClass: BaseHandlerFakeGeneralError },
];

const sharedProviders = [
  { provide: TokenRepo, useClass: TokenDataRepo },
  { provide: IsFirstTimeRepo, useClass: IsFirstTimeDataRepo },
];

const userProviders = [
  { provide: LoginService, useClass: LoginActionService },
  { provide: ResetPasswordService, useClass: ResetPasswordActionService },
  { provide: UserRepo, useClass: UserDataRepo },
  { provide: UserProfilePictureRepo, useClass: UserCapacitorRepo },
  { provide: ThirdPartyLoginService, useClass: ThirdPartyLoginActionService },
  { provide: UserConfigurationRepo, useClass: UserConfigurationDataRepo },
  { provide: InternalApiRepo, useClass: InternalApiDataRepo },
];

const bookingProviders = [{ provide: BookingRepo, useClass: BookingDataRepo }];

const homeProviders = [
  { provide: RecentDataRepo, useClass: GetRecentDataDataRepo },
];

const matchProviders = [
  { provide: MatchRepo, useClass: MatchDataRepo },
  { provide: PlayerRepo, useClass: PlayerDataRepo },
  { provide: DeviceDAO, useClass: LocalStorageDeviceDAO },
];

const walletProviders = [
  { provide: WalletRepo, useClass: WalletDataRepo },
  { provide: RechargeWalletService, useClass: RechargeWalletDataService },
  { provide: IsWalletAvailableService, useClass: IsWalletAvailableDataService },
];

const statisticsProviders = [
  { provide: StatisticsRepo, useClass: StatisticsDataRepo },
];

const onBoardingProviders = [{ provide: StepRepo, useClass: StepDataRepo }];
const termsAndConditionsProviders = [
  { provide: UrlRepo, useClass: UrlDataRepo },
];

const notificationProviders = [
  {
    provide: PushNotificationsService,
    useClass: Capacitor.isNativePlatform()
      ? LibraryPushNotificationsService
      : FakePushNotificationService,
  },
  {
    provide: UserNotificationRepository,
    useClass: UserNotificationDataRepository,
  },
];

const clubProviders = [{ provide: ClubRepo, useClass: ClubDataRepo }];

const communityProviders = [
  { provide: CommunityRepo, useClass: CommunityDataRepo },
  { provide: CommunityPlayersRepo, useClass: CommunityPlayersDataRepo },
];
const courtsProviders = [{ provide: CourtRepo, useClass: CourtDataRepo }];
const VersionProviders = [{ provide: VersionRepo, useClass: VersionDataRepo }];

const ContactProviders = [
  { provide: ContactRepo, useClass: ContactDataRepo },
  { provide: WhatsappRepo, useClass: WhatsappImplRepo },
];
const OpenBrowserProviders = [
  { provide: OpenBrowserUrlRepo, useClass: OpenBrowserUrlRepoImpl },
];

const ChatProviders = [{ provide: ChatRepo, useClass: ChatDataRepo }];

const appUtils = new AppUtils();

const ShareMessageProviders = [];

const CoachProviders = [{ provide: CoachRepo, useClass: CoachRepoImpl }];

const MarketinMessageProviders = [
  { provide: MarketingMessageRepo, useClass: MarketingMessageRepoImpl },
];
//There are some features that depend on the platform,
//so we can provide different providers depending on the platform
if (appUtils.isWeb()) {
  //Case both desktop and mobile web
  if (appUtils.isWebMobile()) {
    //Case mobile web
    ShareMessageProviders.push({
      provide: ShareMessageRepo,
      useClass: ShareMessageMobileWebImplRepo,
    });
  } else {
    //Case desktop web
    ShareMessageProviders.push({
      provide: ShareMessageRepo,
      useClass: ShareMessageDesktopWebImplRepo,
    });
  }
} else {
  //Case capacitor
  ShareMessageProviders.push({
    provide: ShareMessageRepo,
    useClass: ShareMessageCapacitorImplRepo,
  });
}

const matchPlayerProviders = [
  { provide: MatchPlayerRepo, useClass: MatchPlayerDataRepo },
];

const sentryProvider = [
  {
    provide: ErrorHandler,
    useValue: Sentry.createErrorHandler(),
  },
  {
    provide: Sentry.TraceService,
    deps: [Router],
  },
  {
    provide: APP_INITIALIZER,
    useFactory: () => () => {},
    deps: [Sentry.TraceService],
    multi: true,
  },
];

const languageInitializerProvider = [
  {
    provide: APP_INITIALIZER,
    useFactory: (languageService: LanguageService) => () =>
      languageService.initializeLocalization(),
    deps: [LanguageService],
    multi: true,
  },
];

export const providers: (Provider | EnvironmentProviders)[] = [
  provideHttpClient(),
  { provide: BaseHandler },
  ...sentryProvider,
  ...languageInitializerProvider,
  ...sharedProviders,
  ...userProviders,
  ...matchProviders,
  ...homeProviders,
  ...walletProviders,
  ...statisticsProviders,
  ...onBoardingProviders,
  ...termsAndConditionsProviders,
  ...notificationProviders,
  ...bookingProviders,
  ...clubProviders,
  ...communityProviders,
  ...courtsProviders,
  ...VersionProviders,
  ...ContactProviders,
  ...ChatProviders,
  ...ShareMessageProviders,
  ...OpenBrowserProviders,
  ...CoachProviders,
  ...MarketinMessageProviders,
  ...matchPlayerProviders,
  ...fakeProviders, // Uncomment this line to use fake data
  //...fakeAPIErrorProviders,
];
